import app from 'flarum/forum/app';

/** Engagement Centre API calls. Flarum shows validation messages (422) as alerts by itself. */
export function api(method, path, body) {
  return app.request({
    method,
    url: app.forum.attribute('apiUrl') + '/voucha-engagement' + path,
    body
  });
}
export const FIELDS = [['displayName', 'Display name', 'Shown instead of the username'], ['interests', 'Interests', 'Comma-separated'], ['bio', 'Bio', 'One or two sentences']];
export const emptyProfile = () => ({
  displayName: '',
  interests: '',
  bio: ''
});

/** My Community answers, same shape as the member setup form */
export const emptyCommunity = () => ({
  country: '',
  city: '',
  resStateId: null,
  resLgaId: null,
  originStateId: null,
  originLgaId: null,
  profession: '',
  professionOther: '',
  industry: '',
  study: '',
  studyOther: ''
});
export function communityForForm(c) {
  return Object.assign(emptyCommunity(), c && c.form || c || {});
}

/** "Civil engineer · Construction", "Lives in Toronto, Canada", "From Ilorin, Kwara", "Studied ..." */
export function communityLines(c) {
  const l = c && c.lines || {};
  return [l.profession, l.living ? 'Lives in ' + l.living : null, l.origin ? 'From ' + l.origin : null, l.study ? 'Studied ' + l.study : null].filter(Boolean);
}
export function profileForForm(p) {
  const out = emptyProfile();
  Object.keys(out).forEach(k => {
    const v = p && p[k];
    out[k] = Array.isArray(v) ? v.join(', ') : v || '';
  });
  return out;
}
export function ago(at) {
  if (!at) return 'never';
  const d = new Date(String(at).replace(' ', 'T') + (String(at).includes('Z') ? '' : 'Z'));
  const days = Math.floor((Date.now() - d.getTime()) / 864e5);
  if (days < 1) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 31) return days + ' days ago';
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
}

/** <input type="datetime-local"> value for a Date (local time) */
export function localInput(date) {
  const d = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return d.toISOString().slice(0, 16);
}

/** A schedule window starting now: {earliest, latest} as local input values */
export function defaultWindow(hours) {
  if (hours === void 0) {
    hours = 24;
  }
  const now = new Date();
  return {
    earliest: localInput(new Date(now.getTime() + 5 * 60000)),
    latest: localInput(new Date(now.getTime() + hours * 3600000))
  };
}

/** Local input value -> ISO string with offset for the server */
export function toIso(v) {
  return v ? new Date(v).toISOString() : '';
}

/** Server UTC "Y-m-d H:i:s" -> local readable */
export function when(utc) {
  if (!utc) return '';
  const d = new Date(String(utc).replace(' ', 'T') + (/[zZ]|[+-]\d\d:?\d\d$/.test(utc) ? '' : 'Z'));
  return d.toLocaleString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit'
  });
}